import React from "react";
import { StyledDiv } from "./Section6.style";
import '../../assets/css/section.css'
import {Row, Col} from "react-bootstrap" 
const Section6 = () => {
  return (
    <StyledDiv>
       <div className="container prioritisingsecurity">
        <div className="row">
          <div className="col-md-5"></div>
          <div className="col-md-6">
            <Row>
              <Col md={4}>
              </Col>
            <Col md={8} className="">
            <div className="security-info ">
             <h5 className="Prioritising-Security mb-4">Prioritising Security</h5>
              <p className="para-security mb-3">
                There is no place in today's market for a lax approach to privacy
                and data protection. With myindici, our consistent focus is on
                ensuring your data is kept safe and secure. In alignment with the
                world's strictest data protection regulations, we develop our
                technologies based on a "privacy by design and default" principle,
                with security rigorously built in from the outset so you can be
                confident that your data enjoys gold-standard protection.
              </p>
              <p className="para-security ">
                Did you know? myindici will also integrate with the security
                features on your phone, giving you the option to use face
                detection or fingerprint scanning to log in instead of entering a
                username and password.
              </p>
            </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </StyledDiv>
  );
};

export default Section6;
